import { render, staticRenderFns } from "./CampaignName.vue?vue&type=template&id=2a8f53b2&"
import script from "./CampaignName.vue?vue&type=script&lang=js&"
export * from "./CampaignName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8f53b2')) {
      api.createRecord('2a8f53b2', component.options)
    } else {
      api.reload('2a8f53b2', component.options)
    }
    module.hot.accept("./CampaignName.vue?vue&type=template&id=2a8f53b2&", function () {
      api.rerender('2a8f53b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/CampaignName.vue"
export default component.exports